export default __webpack_public_path__ + "static/media/IMG_6687.62c3c222.PNG";